<script setup lang="ts">
import { computed } from 'vue';

withDefaults(defineProps<{
  modelValue: string | undefined;
  label: string;
  errorMessages?: string | string[];
  disabled?: boolean;
  density?: 'default' | 'comfortable' | 'compact';
}>(), { errorMessages: undefined, density: 'compact' });

const emit = defineEmits(['update:modelValue']);

const isSafari = computed(() =>
  /^((?!chrome|android).)*safari/i.test(navigator.userAgent),
);

const safariHint = 'En Safari, debes manualmente seleccionar cada valor.' +
  ' Por ej: a pesar de que por defecto aparezca PM,' +
  ' debes reescribirlo para que funcione.';

function handleTimeChange(event: Event) {
  emit('update:modelValue', (event.target as HTMLInputElement).value);
}
</script>

<template>
  <v-text-field
    :model-value="modelValue"
    type="time"
    :label="label"
    :error-messages="errorMessages"
    :disabled="disabled"
    :hint="isSafari ? safariHint : undefined"
    :persistent-hint="isSafari"
    variant="outlined"
    :density="density"
    @update:model-value="emit('update:modelValue', $event)"
    @change="handleTimeChange"
    @blur="handleTimeChange"
  >
    <template
      v-if="$slots['prepend-inner']"
      #prepend-inner
    >
      <slot name="prepend-inner" />
    </template>
  </v-text-field>
</template>

<style scoped>
/* The native time control is intrinsically taller than a text line, which makes this field
   2px taller than sibling selects/text fields; pin it to the standard line height. */

.v-text-field :deep(input) {
  height: 24px;
}
</style>
